<div [id]="'parent-reading-list-' + listId" class="list-info-item text-muted label-ReadyForProcessing master-reading" *rlPrivileges="['RL_UPDATE_LIST_PRIVILEGE']">
  <ng-container *ngIf="parent">
    <i class="fa fa-sitemap"></i>
    {{ 'list.parent_indication' | translate }}
  </ng-container>
</div>
